<template>
  <div class="c-key" @click="$emit('click')" @dblclick="$emit('dblclick')">
    <div class="texts" v-if="isAny(srcKey)">
      <a-tooltip
        overlayClassName="any-tooltip"
        placement="bottom"
        :mouseLeaveDelay="0.3"
        :visible="selected"
        arrowPointAtCenter
        v-if="getAnyKey(srcKey)"
      >
        <template slot="title">
          {{ $t("keyboard.any.press") }} :
          {{ allKeys[getAnyKey(srcKey).first_key].nowrapText }}<br />
          {{ $t("keyboard.any.hold") }} :
          {{ allKeys[getAnyKey(srcKey).second_key].nowrapText }}<br />
          {{ $t("keyboard.any.interval") }} :
          {{ getAnyKey(srcKey).interval_time }}ms
        </template>
        <div class="text" style="top: 50%;">
          Any
        </div>
      </a-tooltip>
      <div class="text" style="top: 50%;" v-else>
        Any
      </div>
    </div>
    <div class="texts" v-else-if="isMacro(srcKey)">
      <div class="text" style="top: 50%;">{{ getMacroKey(srcKey) }}</div>
    </div>
    <div class="texts" v-else>
      <div
        class="text"
        v-for="(text, index) in getDstKeyText(srcKey)"
        :key="'dstKey' + index"
        :style="text.style"
      >
        {{ text.text }}
      </div>
    </div>
  </div>
</template>
<script>
import { anyKeys, macroKeys } from "./SpecialKeys";

export default {
  name: "CKey",
  props: {
    profile: {
      type: Object,
      default: () => {},
    },
    layer: Array,
    selected: Boolean,
    allKeys: {
      type: Object,
      default: () => {},
    },
    dstKeys: {
      type: Object,
      default: () => {},
    },
    srcKey: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    isAny(srcKey) {
      return anyKeys.includes(this.layer[srcKey.index]);
    },
    getAnyKey(srcKey) {
      const anyKey = this.profile.data.tab_key.find(
        (k) => k.ph_key_data === this.layer[srcKey.index]
      );
      return anyKey;
    },
    isMacro(srcKey) {
      return macroKeys.includes(this.layer[srcKey.index]);
    },
    getMacroKey(srcKey) {
      const macroKey =
        parseInt(this.layer[srcKey.index].replace("#009515", ""), 16) + 1;
      return "M_" + macroKey;
    },
    getDstKeyText(srcKey) {
      return this.dstKeys[this.layer[srcKey.index]]?.text || [];
    },
  },
};
</script>
<style lang="scss">
.c-key {
  position: absolute;
  box-shadow: none;
  cursor: pointer;

  &.selected,
  &:hover {
    box-shadow: 0 0 0 2px $primary-color inset;
  }

  &.disabled {
    box-shadow: none;
    background-color: transparent;
    cursor: inherit;
  }

  .texts {
    width: 100%;
    height: 100%;
    position: relative;

    .text {
      width: 200%;
      text-align: left;
      position: absolute;
      left: 0;
      transform: translate(-25%, -50%) scale(0.5);
      letter-spacing: 0;
      word-break: break-all;
      line-height: 1.2;
    }
  }
}
</style>
<style lang="scss">
.any-tooltip {
  max-width: none;
  position: fixed;
  z-index: 960;

  .ant-tooltip-arrow::before {
    background: $primary-color;
  }
  .ant-tooltip-inner {
    background-color: $primary-color;
    overflow: hidden;
  }
}
</style>
